import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { disableDiscount, enableDiscount, extendDiscount } from "../../api/requestAxios/discounts";
import constants from "../../constants/constants";
import { ErrorToast, InfoToast } from "../../shared";
import btnClose from "../../assets/images/svg/close_modal_icon.svg";
import InputMask from "react-input-mask";
import { toEnglishNumber } from "../../functions";

const Action = ({
    details,
    usable,
    login
}) => {

    const [show, setShow] = useState(false);
    const [title, setTitle] = useState("");
    const [loading, setLoading] = useState(false);
    const [isExtend, setIsExtend] = useState(false)

    const [date, setDate] = useState('');


    const extendCoupon = async (id, date) => {
        try {
            setLoading(true);
            const data = await extendDiscount(id, date)
            setLoading(false);
            InfoToast(constants.CouponExtendedSuccessFully);
            setShow(false)

        }
        catch (err) {
            setLoading(false);
            ErrorToast(err)
            setShow(false)
        }
    };
    const handleClose = () => {
        setShow(false)
        setTitle('')
    }

    const enableCoupon = async (id) => {
        try {
            setLoading(true);
            const data = await enableDiscount(id)
            setLoading(false);
            InfoToast(constants.CouponDisabledSuccessFully);
            setShow(false)
        }
        catch (err) {
            setLoading(false);
            ErrorToast(err)
            setShow(false)
        }
    };
    const disableCoupon = async (id) => {
        try {
            setLoading(true);
            const data = await disableDiscount(id)
            setLoading(false);
            InfoToast(constants.CouponDisabledSuccessFully);
            setShow(false)
        }
        catch (err) {
            setLoading(false);
            ErrorToast(err)
            setShow(false)
        }
    };

    return (
        <div className="d-flex justify-content-between align-items-center rtl">
            <div className="mt-3 rtl">
                <b>{details?.code}</b>
                <div className={`details?.usable` ? 'enabled' : 'disabled'}>
                    {usable ? 'فعال' : 'غیر فعال'}
                </div>

            </div>
            <div className="d-flex justify-content-between">
                <button
                    onClick={() => {
                        setTitle('تمدید اعتبار زمانی')
                        setShow(true)
                        setIsExtend(true)
                    }}
                    className="submit-button btn btn-primary" style={{ margin: '10px' }}>
                    تمدید مهلت
                </button>
                <button
                    onClick={() => {
                        setTitle(`${usable ? ' غیر فعالسازی کد' : 'غعالسازی کد'}`)
                        setShow(true)
                        setIsExtend(false)
                    }}
                    className={`submit-button cancel-button btn btn-primary ${usable ? "cancel-button " : ""}`} style={{ margin: '10px' }}>
                    {usable ? ' غیر فعالسازی کد' : 'غعالسازی کد'}
                </button>

            </div>
            <Modal show={show} onHide={handleClose} animation={true} dir="rtl" className="invoice-modal">
                <Modal.Header>
                    <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                        {title}
                        <img
                            onClick={handleClose}
                            alt={''}
                            src={btnClose}
                        />
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className='invoice-modal-content-view'>
                    {isExtend &&
                        <div className="d-flex justify-content-between">
                            <label>  تمدید تاریخ</label>
                            <InputMask
                                mask="9999/99/99"
                                placeholder={toEnglishNumber(new Date().toLocaleDateString("fa-IR", {
                                    month: '2-digit', day: '2-digit', year: 'numeric'
                                }))}
                                className="normal-input-discount-extend"
                                type="text"
                                onChange={(e) => setDate(e.target.value)}
                            />
                        </div>

                    }

                    {!isExtend && <div d-flex justify-content-center align-items-center>
                        <span>کد تخفیف:</span>
                        <span>{details?.code}</span>
                    </div>}
                </Modal.Body>

                <Modal.Footer>
                    <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                        {isExtend && <button onClick={() => extendCoupon(details?.id, date)} className="button-invoice-approve" style={{ width: '100%' }}>تمدید مهلت</button>}
                        {!isExtend && <button onClick={() => { usable ? disableCoupon(details?.id) : enableCoupon(details?.id) }} className={`${usable ? "button-invoice-reject " : "button-invoice-approve"}`} style={{ width: '100%' }}> {usable ? ' غیر فعالسازی کد' : 'غعالسازی کد'}</button>}
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Action

